module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/firms/firms.component.scss
// module id = ./src/app/routes/firms/firms.component.scss
// module chunks = 9